import I18N from '@leverege/i18n'
import { DataViewerModel } from '@leverege/molten/data-viewers'

import EventsView from '../events/EventsView'
import EventsViewModel from '../events/EventsViewModel'

import AnalyticsSupportDataViewer from './AnalyticsSupportDataViewer'

const { tf, tfIcon } = I18N.ns( 'ps.dataViewers.AnalyticsEventsDataViewer' )

export default {
  id : 'ps.dataViewers.AnalyticsEventsDataViewer',
  type : 'ps.AnalyticsEvents',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : [ 'main', 'card' ],
  matches : { type : [ 'GroupDataViewer', 'ItemInfoDataViewer' ], objectType : 'station' },
  createSettings : ( props ) => {

    return EventsViewModel.create( {
      dataViewers : [ 
        DataViewerModel.create( 
          AnalyticsSupportDataViewer.type, 
          AnalyticsSupportDataViewer.createSettings( props ) )
      ],
      breakpoints : [ 'minWidth' ]
    } )
  },
  component : EventsView,
  getDefaultCardContentOptions : { height : '400px' }
}
